import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuditTrailExportFailedAction = {
	type: 'AUDIT_TRAIL_EXPORT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuditTrailExportFailedAction => ({
	type: 'AUDIT_TRAIL_EXPORT_FAILED',
	payload,
});
